import { render, staticRenderFns } from "./AdminMatchesSectorContainer.vue?vue&type=template&id=2053eb9c&scoped=true"
import script from "./AdminMatchesSectorContainer.vue?vue&type=script&lang=js"
export * from "./AdminMatchesSectorContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2053eb9c",
  null
  
)

export default component.exports